<template>
  <div id="agSNConn">
    <div class="agInputGroup agInputGroupCentered">
    </div>
  </div>
</template>

<script>
// components

// server

// modules

export default {
  name: "ag-sn-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/SNConnection.vue